






















































































































































































import {Component, Vue} from 'vue-property-decorator';

const modalData = [
  {
    name: '',
  },
  {
    name: '音符',
  },
  {
    name: '现在的曲数/本局可以游玩的曲数',
  },
  {
    name: '歌曲分数',
  },
  {
    name: '歌曲的难度',
  },
  {
    name: '达成率',
    description: '音符输入正确的时候就会增加达成率，达到一定的达成率就可以通关'
  },
  {
    name: '连击数',
    description: '连续输入正确的话连击数会增加'
  },
  {
    name: '判定线',
    description: '当音符和判定线重合的时候进行点击就可以获得分数哦'
  }
]
@Component
export default class HowToGameMode extends Vue {
  modalOpen = false;
  modalName = '';
  modalIndex = 1;
  modalDescription ? = '';

  openModal(index: number): void {
    if (index !== -2) {
      this.modalName = modalData[index].name;
      this.modalDescription = modalData[index].description ? modalData[index].description : '';
    }
    this.modalIndex = index;
    this.modalOpen = true;
  }

  closeModal(): void {
    this.modalOpen = false;
    this.modalName = '';
    this.modalIndex = -1;
    this.modalDescription = '';
  }
}
